<template>
  <div :class="['index-menu-list-container', {'index-menu-list-container-active': menuKey == currentMenuId && theme}]">
    <template v-if="data.children.length !== 0">
      <el-submenu :index="data.id" :key="data.id" v-show="data.show">
        <template slot="title">
          <img class="icon" v-if="data.icon" :src="`${origin}${data.icon}`"></img>
          <span
          class="second-menu"
          :data-id="data.id"
          :title="data.name">
          {{getNames(data.name)}}
        </span>
        </template>
        <template v-for="childItem in data.children">
          <menu-list :data="childItem" :key="childItem.id" :currentMenuId="currentMenuId" @toChildRouter="toChildRouter"></menu-list>
        </template>
      </el-submenu>
    </template>
    <el-menu-item
      class="menu-name-overflow"
      v-if="data.children.length === 0"
      :index="data.link && data.link.includes('report-full-screen')?'':'/main'+data.link||'/'"
      v-show="data.show"
      :data-id="data.id"
      @click="toChildRouter(data.id,data.name,data)"
      :disabled="!data.link || data.disabled"
      :title="data.name"
      :class="currentMenuId === data.id && 'active-menu'">
      <template slot="title">
          <img class="icon" v-if="data.icon" :src="`${origin}${data.icon}`"></img>
          <span
          class="second-menu"
          :data-id="data.id"
          :title="data.name">
          {{getNames(data.name,11)}}
        </span>
        </template>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    currentMenuId: String,
    menuKey: String
  },
  name: 'menu-list',
  data () {
    let theme = this.$theme && this.$theme.themeColor
    return {
      theme,
      origin: ''
    }
  },
  created () {
    this.origin = sessionStorage.getItem('ossDownloadUrl')
  },
  methods: {
    toChildRouter (id, name, item) {
      // 如果是全屏的报表，新打开标签页
      if (item && item.link && item.link.includes('report-full-screen')) {
        let array = item.link.split('/')
        let reportId = array.pop()
        let href = `${location.origin}/report-full-screen?id=${reportId}&token=${this.$route.query.token}&title=${document.title}`
        window.open(href, '_blank')
      } else {
        this.$emit('toChildRouter', id, name, item)
      }
    }
  },
  computed: {
    getNames () {
      return (name, lenght = 7) => name.length > lenght ? `${name.substring(0, (lenght > 7 ? lenght - 1 : lenght))}...` : name
    }
  }
}
</script>

<style lang="scss">
  .index-menu-list-container {
    .icon{
      width: 15px;
      height: 15px;
    }
    &.index-menu-list-container-active{
      border-right: 2px solid var(--primary, transparent);
      background-color: #E6E6E6;
    }
    .el-submenu .el-menu-item.menu-name-overflow {
      min-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/menu-list.vue